/*
----------------------------------------------------------------------------------------
Mobile Menu
----------------------------------------------------------------------------------------
*/

const body = document.querySelector('body')
const mobile_menu = document.querySelector('.mobile-menu > ul')
const mobile_menu_toggles = document.querySelectorAll('.mobile-nav-toggle')
const mobile_menu_submenu_links = document.querySelectorAll('.mobile-menu > ul > li.menu-item-has-children > a')
const mobile_menu_submenus = document.querySelectorAll('.mobile-menu > ul > li.menu-item-has-children > .sub-menu')

// Controls the mobile menu toggle button
mobile_menu_toggles.forEach(button => {
    button.addEventListener('click', (e) => {
        const open = button.getAttribute('aria-expanded') === 'true'
        body.classList.toggle('menu-open')
        mobile_menu.classList.toggle('menu-open')
        mobile_menu.parentNode.classList.remove('hidden')
        if (!open) {
            button.setAttribute('aria-expanded', 'true')
        } else {
            button.setAttribute('aria-expanded', 'false')
            mobile_menu_submenus.forEach(menu => menu.classList.remove('show'))
        }
    })
})

// Controls the mobile submenu links
mobile_menu_submenu_links.forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault()
        const target = link.getAttribute('aria-controls')
        const submenu = document.querySelector('#' + target)
        submenu.classList.add('show')
    })
})

// Adds back buttons to mobile submenus
mobile_menu_submenus.forEach(submenu => {
    const list_item = document.createElement("li")
    const link = document.createElement("a")
    link.setAttribute('href', "#")
    link.setAttribute('class', 'back-to-main')
    link.innerHTML = "Back to Main Menu"

    link.addEventListener('click', e => {
        e.preventDefault()
        submenu.classList.remove('show')
    })

    list_item.appendChild(link)
    submenu.prepend(list_item)
})


/*
----------------------------------------------------------------------------------------
Main Menu
----------------------------------------------------------------------------------------
*/

const main_menu = document.querySelector('.main-menu > ul')
const dropdown_items = document.querySelectorAll('.main-menu > ul > li.menu-item-has-children')
let active_dropdown = null

// Controls the dropdown menus when clicked
dropdown_items.forEach(item => {
    const link = item.querySelector('a')
    link.addEventListener('click', (e) => {
        e.preventDefault()
        const open = link.getAttribute('aria-expanded') === 'true'
        if (!open) {
            open_dropdown(link)
        } else {
            close_dropdown(link)
        }
    })
})

// Closes the active dropdown menu when clicking outside the menu
document.addEventListener('click', (e) => {
    if (!active_dropdown) {
        return;
    }

    if (e.target !== main_menu && !main_menu.contains(e.target)) {
        close_dropdown(active_dropdown)
    }
}, {passive: true})

// Closes the active dropdown if ESC key is pressed
document.addEventListener('keyup', (e) => {
    if (!active_dropdown) {
        return;
    }

    if (e.key === "Escape") {
        close_dropdown(active_dropdown)
    }
}, {passive: true})

const close_dropdown = (link) => {
    const target = link.getAttribute('aria-controls')
    const dropdowns = document.querySelectorAll('#' + target)
    active_dropdown = null
    link.setAttribute('aria-expanded', 'false')
    dropdowns.forEach(dropdown => dropdown.classList.remove('open'))
}

const open_dropdown = (link) => {
    const target = link.getAttribute('aria-controls')
    const dropdowns = document.querySelectorAll('#' + target)
    if (active_dropdown) {
        close_dropdown(active_dropdown)
    }
    active_dropdown = link
    link.setAttribute('aria-expanded', 'true')
    dropdowns.forEach(dropdown => dropdown.classList.add('open'))
}